export enum PhoneMakers {
  APPLE = 'Apple',
  SAMSUNG = 'Samsung',
  OTHER = 'Other',
}
